<section class="experience-section py-5" id="experience">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 mx-auto text-center mb-5">
        <h2 class="section-title">{{ i18n.getTranslation('experience.title') }}</h2>
        <p class="section-subtitle">{{ i18n.getTranslation('experience.subtitle') }}</p>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-12 col-lg-10">
        <div class="experience-list">
          <div
            class="experience-card mb-4 animate-in"
            *ngFor="let exp of visibleExperiences; let i = index"
            [style.animation-delay.ms]="i * 150">
            <div class="experience-header">
              <h4 class="experience-title">{{ exp.title }}</h4>
              <h5 class="experience-company">{{ exp.company }}</h5>
              <span class="experience-period">{{ exp.period }}</span>
            </div>
            <p class="experience-description">{{ exp.description }}</p>
            <div class="experience-technologies" *ngIf="exp.technologies && exp.technologies.length > 0">
              <span class="tech-badge" *ngFor="let tech of exp.technologies">
                {{ tech }}
              </span>
            </div>
          </div>
        </div>

        <div class="text-center mt-4" *ngIf="experiences.length > 2">
          <button
            class="btn btn-outline-primary"
            (click)="toggleExperiences()">
            {{ buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
